import {ref} from 'vue';
import {defineStore} from 'pinia';
import type {RouteLocationPathRaw, RouteLocationNamedRaw} from 'vue-router';
import {useLogger} from '#imports';
import {readonlyState} from '@malt/utils';

export const useRestrictionsStore = defineStore('restrictions', () => {
    const logger = useLogger();

    const shouldRedirectExternal = ref<RouteLocationPathRaw | RouteLocationNamedRaw>();
    const performedTooMuchSearch = ref(false);

    function userPerformedTooMuchSearch() {
        performedTooMuchSearch.value = true;
    }

    function redirectExternal(to: RouteLocationPathRaw | RouteLocationNamedRaw) {
        if (!shouldRedirectExternal.value) {
            logger.debug(`User should be redirected to ${to.path}`);
            shouldRedirectExternal.value = to;
        } else {
            logger.debug(`User won't be redirected to ${to.path} because a redirect has already been done to ${shouldRedirectExternal.value.path}`);
        }
    }

    return {
        performedTooMuchSearch: readonlyState(performedTooMuchSearch),
        shouldRedirectExternal,
        redirectExternal,
        userPerformedTooMuchSearch,
    };
});
